<template>
  <div catchtouchmove="true" :class="value && complete ? 'show' : 'none'">
    <div class="specification-header">
      <div class="specification-left">
        <img
          id="product-img"
          :src="selectShop.image ? selectShop.image : goodsInfo[goodsThumbName]"
          mode="aspectFill"
        />
        <ul id="gallery" class="thumb-list clearfix">
          <li v-for="(cItem, cIndex) in detailImageArray" :key="cIndex">
            <img :src="allImageUrl(cItem)" />
          </li>
        </ul>
      </div>
      <div class="specification-right">
        <div class="title">
          <h1>{{ goodsInfo.name }}</h1>
        </div>
        <div
          class="price-content"
          :style="{
            color: themeColorFn('priceColor'),
          }"
        >
          <span class="sign">¥</span>
          <span class="price" :class="priceCom.length > 16 ? 'price2' : ''">
            {{ priceCom }}
          </span>
        </div>
        <div
          v-show="isManyCom"
          class="specification-item"
          v-for="(item, index1) in goodsInfo[specListName]"
          :key="index1"
        >
          <div class="item-title">{{ item.name }}</div>
          <div class="item-wrapper">
            <div
              class="item-content"
              v-for="(item_value, index2) in item.list"
              :key="index2"
              :class="[
                item_value.ishow ? '' : 'noactived',
                subIndex[index1] == index2 ? 'actived' : '',
              ]"
              :style="[
                item_value.ishow ? '' : themeColorFn('disableStyle'),
                item_value.ishow ? themeColorFn('btnStyle') : '',
                subIndex[index1] == index2 ? themeColorFn('activedStyle') : '',
              ]"
              @click="skuClick(item_value, index1, index2)"
            >
              {{ item_value.name }}
            </div>
          </div>
        </div>
        <div class="number-box-div">
          <div
            style="float: left; width: 70px; color: #515457; line-height: 32px"
          >
            数量
          </div>
          <div style="">
            <vk-data-input-number-box
              v-model="selectNum"
              :min="minBuyNum || 1"
              :max="maxBuyNumCom"
              :step="stepBuyNum || 1"
              :step-strictly="stepStrictly"
              :positive-integer="true"
            ></vk-data-input-number-box>
          </div>
        </div>
        <div
          class="specification-item"
          style="margin-bottom: 30px; position: relative"
        >
          <div class="item-title">{{ stockText }}</div>
          <div class="item-wrapper" style="line-height: 32px">
            {{ stockCom }}
          </div>
          <div class="tips-dialog" v-show="tipsShow">
            <span class="delete" @click="dialogHidden()">X</span>
            <img src="../../assets/images/icon-completed.png" />
            成功加入购物车！
          </div>
          <!-- <div class="choose" v-show="isManyCom">
          已选：{{ selectArr.join(' ') }}
        </div> -->
        </div>
        <div class="btn-wrapper" v-if="outFoStock || mode == 4">
          <div class="sure" style="color: #ffffff; background-color: #cccccc">
            {{ noStockText }}
          </div>
        </div>
        <div class="btn-wrapper" v-else-if="mode == 1">
          <div
            class="sure add-cart"
            style="border-radius: 4px"
            @click="addCart"
            :style="{
              color: themeColorFn('addCartColor'),
              backgroundColor: themeColorFn('addCartBackgroundColor'),
              border: themeColorFn('addCartBorder'),
            }"
          >
            {{ addCartText }}
          </div>
          <div
            class="sure"
            style="border-radius: 4px"
            @click="buyNow"
            :style="{
              color: themeColorFn('buyNowColor'),
              backgroundColor: themeColorFn('buyNowBackgroundColor'),
              border: themeColorFn('buyNowBorder'),
            }"
          >
            {{ buyNowText }}
          </div>
        </div>
        <div class="btn-wrapper" v-else-if="mode == 2">
          <div
            class="sure add-cart"
            @click="addCart"
            :style="{
              color: themeColorFn('addCartColor'),
              backgroundColor: themeColorFn('addCartBackgroundColor'),
            }"
          >
            {{ addCartText }}
          </div>
        </div>
        <div class="btn-wrapper" v-else-if="mode == 3">
          <div
            class="sure"
            @click="buyNow"
            :style="{
              color: themeColorFn('buyNowColor'),
              backgroundColor: themeColorFn('buyNowBackgroundColor'),
            }"
          >
            {{ buyNowText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var vk; // vk依赖
import $ from 'jquery';
import vkDataInputNumberBox from '@/components/vk-data-input-number-box/vk-data-input-number-box.vue';
import { getImageAllUrl } from '../../setup/common';
var goodsCache = {}; // 本地商品缓存
export default {
  name: 'vk-data-goods-sku-popup',
  components: { vkDataInputNumberBox },
  // 过滤器
  filters: {
    // 金额显示过滤器
    priceFilter(n = 0) {
      if (typeof n == 'string') {
        n = parseFloat(n);
      }
      return (n / 100).toFixed(2);
    },
  },
  props: {
    //商品详情imageArray
    detailImageArray: {
      Type: Array,
      default: [],
    },
    // true 组件显示 false 组件隐藏
    value: {
      Type: Boolean,
      default: true,
    },
    // vk云函数路由模式参数开始-----------------------------------------------------------
    // 商品id
    goodsId: {
      Type: String,
      default: '',
    },
    // vk路由模式框架下的云函数地址
    action: {
      Type: String,
      default: '',
    },
    // vk云函数路由模式参数结束-----------------------------------------------------------
    // 该商品已抢完时的按钮文字
    noStockText: {
      Type: String,
      default: '该商品已抢完',
    },
    // 库存文字
    stockText: {
      Type: String,
      default: '库存',
    },
    // 商品表id的字段名
    goodsIdName: {
      Type: String,
      default: '_id',
    },
    // sku表id的字段名
    skuIdName: {
      Type: String,
      default: '_id',
    },
    // sku_list的字段名
    skuListName: {
      Type: String,
      default: 'sku_list',
    },
    // spec_list的字段名
    specListName: {
      Type: String,
      default: 'spec_list',
    },
    // 库存的字段名 默认 stock
    stockName: {
      Type: String,
      default: 'stock',
    },
    // sku组合路径的字段名
    skuArrName: {
      Type: String,
      default: 'sku_name_arr',
    },
    // 默认单规格时的规格组名称
    defaultSingleSkuName: {
      Type: String,
      default: '默认',
    },
    // 模式 1:都显示  2:只显示购物车 3:只显示立即购买 4:显示缺货按钮 默认 1
    mode: {
      Type: Number,
      default: 1,
    },
    // 点击遮罩是否关闭组件 true 关闭 false 不关闭 默认true
    maskCloseAble: {
      Type: Boolean,
      default: true,
    },
    // 顶部圆角值
    borderRadius: {
      Type: [String, Number],
      default: 0,
    },
    // 商品缩略图字段名(未选择sku时)
    goodsThumbName: {
      Type: [String],
      default: 'goods_thumb',
    },
    // 最小购买数量 默认 1
    minBuyNum: {
      Type: [Number, String],
      default: 1,
    },
    // 最大购买数量 默认 100000
    maxBuyNum: {
      Type: [Number, String],
      default: 100000,
    },
    // 步进器步长 默认 1
    stepBuyNum: {
      Type: [Number, String],
      default: 1,
    },
    // 是否只能输入 step 的倍数
    stepStrictly: {
      Type: Boolean,
      default: false,
    },
    // 自定义获取商品信息的函数
    customAction: {
      Type: [Function],
      default: null,
    },
    // 价格的字体颜色
    priceColor: {
      Type: String,
    },
    // 立即购买按钮的文字
    buyNowText: {
      Type: String,
      // default: "立即购买"
      default: '立即购买',
    },
    // 立即购买按钮的字体颜色
    buyNowColor: {
      Type: String,
    },
    // 立即购买按钮的背景颜色
    buyNowBackgroundColor: {
      Type: String,
    },
    // 加入购物车按钮的文字
    addCartText: {
      Type: String,
      default: '加入购物车',
    },
    // 加入购物车按钮的字体颜色
    addCartColor: {
      Type: String,
    },
    // 加入购物车按钮的背景颜色
    addCartBackgroundColor: {
      Type: String,
    },
    // 不可点击时,按钮的样式
    disableStyle: {
      Type: Object,
      default: null,
    },
    // 按钮点击时的样式
    activedStyle: {
      Type: Object,
      default: null,
    },
    // 按钮常态的样式
    btnStyle: {
      Type: Object,
      default: null,
    },
    // 是否显示右上角关闭按钮
    showClose: {
      Type: Boolean,
      default: true,
    },
    // 关闭按钮的图片地址 https://img.alicdn.com/imgextra/i1/121022687/O1CN01ImN0O11VigqwzpLiK_!!121022687.png
    closeImage: {
      Type: String,
      default:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAEyUlEQVR42sSZeWwNURTGp4OqtBo7sSXELragdkpQsRRJ1Zr4hyJiJ9YgxNIg1qANiT+E1i5IY0kVVWtQEbuEKLFGUSH27/ANN5PXmTvzupzkl/tm8t6b7517lnvvC0lKSjJ8WmnQAUSDFqABqALKgl8gD7wE90E2SAeXwFf1SxISErQeVtKHwCgwFsSDSIf3hYFKoCkYDBaDdyAViHdueHmoF6FtwDLQ23b/E7gM7oIcejIERIDaoBFoC8qA8mA8SQNz6W1XC9GY+nCQCCYAk/c+gF0gBZwH312+IxR0BCPBUIaH2A+wHsxHCHxx+gLT5QGN6a2JfG8uvVCDws9oiDQYlxkMGfHyQvARlADTwcXk5OT6foV2kS8ATXidymlcyen1a/Jjl9IJh3hPkjELYqO8Cu0KjjNZvtETw5jFBWXPmGSTGQKSeOn5iQ0kVLL0CINfPNcPbDMKyRCbGzEMBJ+ZD8cChYFdqGTqfsWT8otPGoVsEHsMwxDFs3shNsxJ6BrQ0Po8OGUUkVHsNCVml+cntB1jUWwn2GEUsTEMrASbDK+2CCQ0kYX6nfLLisMmKqUr0S60M+jG10vAm+JSCa8+x7CKlzHwaktV6DiObzUzPJIxFO1BQ12wGtTReO9GetVgY/kjNJzZbcWmTjHfxw51AsRqvL8eOAtmsJuFu3g1l+1ZLB5eDTVZ3K0P7tL0TkWOpSg61kVkBtuuNRthGs+wtJST5aQI7cEbkkRXNYVKgX6kIdYuUhYzMQwxN8tiExCLFqHNeSF9/aem0BzGp5PYQCJ7c/Gsk1RfuSD6U1dNpcDf9ZigTmKbMRZ9iVTsHscGJluW2FMf1SSQWGnBmaB6kCJVTVVNJZE++Cx9drEllS1KMCINpURFmEbBWA63Fz9s95cGIdJgp/zXmT4pZcOvSUzuZttTbblmnc3PIjjmidDXvKgdhMh0JdbzuCjWrbNOVovjS5P7bkPJ/mBESkz2BO0166ybNeJ431S2q+01NntuIq3E0amzjiZtk9tssWyTDzO4525bACK9NAUn68TtkNhpEXpOSagRml+S6iLSSeweHv242Qhl13rRyvoDvDlKyTQny/ZQJ+1iH7vVbEx7OR5UiKVIO7VicgvHCtwrudloMIV7/0uadVYW57O4Wvvi8v4pymlKkrpwvsDeLLZAY2pkwbAB3PSQfC+4cH7l4k1ZH8zkZRq8ecO+Z5rN40JJqnXFuGfaxPCTLjcn0OZOpnArXw8HY4paIbw5CcMgXq6HN2/mt6+XGLrN15tBryIUGavMpCTrfKcDCKkAceA9S8nhAOehhSUyhXpkBxxnP4YM1InugP7cBkjBPcqVUWFYCEROxXiQz5JlXV+IfKh7mpfJac+lZ6V87QXVClBkTc7YWsWTPSDyitfzUTlJlj8TbvE6jluDOdwZ+jX57GLO3ADeuyZrDYi86vV81FD2UVGsmT+5Zl0BnkhoseOEaogL46pqO4v/IqUEyalIR4h85BgjHv6+aUWRMbb7EstX6O0cpT1Gco0ry8fWygLDMjmDnQeBt3Qe7uVfkeugDwVLcsVzGsuwLXbV+I63XNAkG5r/hvgRqgqWs6pJPKrsbvz/Q6yyun0w/h6lP+BnzrCpfPMT2L8FGAA7k1GZ/vnaqAAAAABJRU5ErkJggg==',
    },
    // 是否隐藏库存显示
    hideStock: {
      Type: Boolean,
      default: false,
    },
    // 颜色主题
    theme: {
      Type: String,
      default: 'default',
    },
    // 请求中的提示
    actionTips: {
      Type: String,
      default: '请求中...',
    },
    // 默认选中的SKU
    defaultSelect: {
      Type: Object,
    },
    // 是否使用缓存
    useCache: {
      Type: Boolean,
      default: true,
    },
    /**
     * 默认商品,设置该值可快速展示商品
     * 逻辑: 先展示 defaultGoods 信息,再取数据库,再更新页面(通常为更新库存)
     */
    defaultGoods: {
      Type: Object,
    },
  },
  data() {
    return {
      complete: true, // 组件是否加载完成
      goodsInfo: {}, // 商品信息
      isShow: false, // true 显示 false 隐藏
      initKey: true, // 是否已初始化
      shopItemInfo: {}, // 存放要和选中的值进行匹配的数据
      selectArr: [], // 存放被选中的值
      subIndex: [], // 是否选中 因为不确定是多规格还是单规格，所以这里定义数组来判断
      selectShop: {}, // 存放最后选中的商品
      selectNum: this.minBuyNum || 1, // 选中数量
      outFoStock: false, // 是否全部sku都缺货
      openTime: 0,
      tipsShow: false,
      intervalId: null,
      themeColor: {
        // 默认主题
        default: {
          priceColor: 'rgb(254, 86, 10)',
          buyNowColor: '#F15B49',
          buyNowBackgroundColor: '#FFF1F0',
          buyNowBorder: '2px solid #F15B49',
          addCartColor: '#FFFFFF',
          addCartBackgroundColor: '#F15B49',
          addCartBorder: '2px solid #F15B49',
          btnStyle: {
            color: '#666',
            borderColor: '#EDEDED',
            backgroundColor: '#F7F7FA',
          },
          activedStyle: {
            color: '#854fc1',
            borderColor: '#854fc1',
            backgroundColor: '#f2ecf8',
          },
          disableStyle: {
            color: '#c3c3c3',
            borderColor: '#f6f6f6',
            backgroundColor: '#f6f6f6',
          },
        },
      },
    };
  },
  // 计算属性
  computed: {
    // 最大购买数量
    maxBuyNumCom() {
      let that = this;
      let max = that.maxBuyNum || 100000;
      let stockName = that.stockName;
      if (
        that.selectShop &&
        typeof that.selectShop[stockName] !== 'undefined'
      ) {
        // 最大购买量不能超过当前商品的库存
        if (max > that.selectShop[stockName]) {
          max = that.selectShop[stockName];
        }
      }
      return max;
    },
    // 是否是多规格
    isManyCom() {
      let that = this;
      let { goodsInfo, defaultSingleSkuName, specListName } = that;
      let isMany = true;
      if (
        goodsInfo[specListName] &&
        goodsInfo[specListName].length === 1 &&
        goodsInfo[specListName][0].list.length === 1 &&
        goodsInfo[specListName][0].name === defaultSingleSkuName
      ) {
        isMany = false;
      }
      return isMany;
    },
    // 默认价格区间计算
    priceCom() {
      let str = '';
      let that = this;
      let { selectShop = {}, goodsInfo = {}, skuListName, goodsIdName } = that;
      if (selectShop[goodsIdName]) {
        str = that.priceFilter(selectShop.price);
      } else {
        let skuList = goodsInfo[skuListName];
        if (skuList && skuList.length > 0) {
          let valueArr = [];
          skuList.map((skuItem, index) => {
            valueArr.push(skuItem.price);
          });
          let min = that.priceFilter(Math.min(...valueArr));
          let max = that.priceFilter(Math.max(...valueArr));
          if (min === max) {
            str = min + '';
          } else {
            str = `${min} - ${max}`;
          }
        }
      }
      return str;
    },
    // 库存显示
    stockCom() {
      let str = '';
      let that = this;
      let { selectShop = {}, goodsInfo = {}, skuListName, stockName } = that;
      if (selectShop[stockName]) {
        str = selectShop[stockName];
      } else {
        let skuList = goodsInfo[skuListName];
        if (skuList && skuList.length > 0) {
          let valueArr = [];
          skuList.map((skuItem, index) => {
            valueArr.push(skuItem[stockName]);
          });
          let min = Math.min(...valueArr);
          let max = Math.max(...valueArr);
          if (min === max) {
            str = min;
          } else {
            str = `${min} - ${max}`;
          }
        }
      }
      return str;
    },
  },
  watch: {
    value(newVal, oldValue) {
      let that = this;
      //that.open();
      if (newVal) {
        that.open();
      }
    },
    defaultGoods: {
      immediate: true,
      handler: function(newVal, oldValue) {
        let that = this;
        let { goodsIdName } = that;
        if (
          typeof newVal === 'object' &&
          newVal &&
          newVal[goodsIdName] &&
          !goodsCache[newVal[goodsIdName]]
        ) {
          that.pushGoodsCache(newVal);
        }
      },
    },
  },
  created() {
    let that = this;
    vk = that.vk;
    if (that.value) {
      that.open();
    }
  },
  mounted() {
    // 点击小图切换大图
    $('#gallery li img').click(function() {
      var src = $(this).attr('src');
      $('#product-img').attr({ src: src });
      $(this)
        .parents()
        .addClass('active')
        .siblings()
        .removeClass('active');
    });
  },
  methods: {
    allImageUrl(str) {
      return getImageAllUrl(str);
    },
    // 初始化
    init(notAutoClick) {
      let that = this;
      // 清空之前的数据
      //that.goodsCache = {};
      that.selectArr = [];
      that.subIndex = [];
      that.selectShop = {};
      that.selectNum = that.minBuyNum || 1;
      that.outFoStock = false;
      that.shopItemInfo = {};

      let specListName = that.specListName;
      if (that.goodsInfo[specListName]) {
        that.goodsInfo[specListName].map((item) => {
          that.selectArr.push('');
          that.subIndex.push(-1);
        });
      }
      that.checkItem(); // 计算sku里面规格形成路径
      that.checkInpath(-1); // 传-1是为了不跳过循环
      if (!notAutoClick) that.autoClickSku(); // 自动选择sku策略
    },
    // 使用vk路由模式框架获取商品信息
    findGoodsInfo(obj = {}) {
      let that = this;
      let { useCache } = obj;
      if (typeof vk == 'undefined') {
        alert('custom-action必须是function', 'none');
        return false;
      }
      let { actionTips } = that;
      let actionTitle = '';
      let actionAoading = false;
      if (actionTips !== 'custom') {
        actionTitle = useCache ? '' : '请求中...';
      } else {
        actionAoading = useCache ? false : true;
      }
      /*
      vk.callFunction({
        url: that.action,
        title: actionTitle,
        loading: actionAoading,
        data: {
          goods_id: that.goodsId,
        },
        success(data) {
          that.updateGoodsInfo(data.goodsInfo);
          // 更新缓存
          goodsCache[that.goodsId] = data.goodsInfo;
          that.$emit('update-goods', data.goodsInfo);
        },
        fail() {
          that.updateValue(false);
        },
      });*/
    },
    updateValue(value) {
      let that = this;
      if (value) {
        that.$emit('open', true);
        that.$emit('input', true);
      } else {
        that.$emit('input', false);
        that.$emit('close', 'close');
      }
    },
    // 更新商品信息(库存、名称、图片)
    updateGoodsInfo(goodsInfo) {
      let that = this;
      let { skuListName } = that;
      if (
        JSON.stringify(that.goodsInfo) === '{}' ||
        that.goodsInfo[that.goodsIdName] !== goodsInfo[that.goodsIdName]
      ) {
        that.goodsInfo = goodsInfo;
        that.initKey = true;
      } else {
        that.goodsInfo[skuListName] = goodsInfo[skuListName];
      }
      that.init();
      // if (that.initKey) {
      //   that.initKey = false;
      //   that.init();
      // }
      // 更新选中sku的库存信息
      let select_sku_info = that.getListItem(
        that.goodsInfo[skuListName],
        that.skuIdName,
        that.selectShop[that.skuIdName],
      );
      Object.assign(that.selectShop, select_sku_info);
      that.defaultSelectSku();
      that.complete = true;
    },
    async open() {
      let that = this;
      that.openTime = new Date().getTime();
      let findGoodsInfoRun = true;
      let skuListName = that.skuListName;

      // // 先获取缓存中的商品信息
      let useCache = false;
      let goodsInfo = goodsCache[that.goodsId];
      if (goodsInfo && that.useCache) {
        useCache = true;
        that.updateGoodsInfo(goodsInfo);
      } else {
        that.complete = false;
      }
      if (that.customAction && typeof that.customAction === 'function') {
        let goodsInfo = await that.customAction({
          useCache,
          goodsId: that.goodsId,
          goodsInfo,
        });
        // 更新缓存
        goodsCache[that.goodsId] = goodsInfo;
        if (
          goodsInfo &&
          typeof goodsInfo == 'object' &&
          JSON.stringify(goodsInfo) != '{}'
        ) {
          findGoodsInfoRun = false;
          that.updateGoodsInfo(goodsInfo);
          that.updateValue(true);
        } else {
          console.log('未获取到商品信息');
          that.$emit('input', false);
          return false;
        }
      } else {
        if (findGoodsInfoRun) that.findGoodsInfo({ useCache });
      }
    },
    // 监听 - 弹出层收起
    close(s) {
      let that = this;
      if (new Date().getTime() - that.openTime < 400) {
        return false;
      }
      if (s == 'mask') {
        if (that.maskCloseAble !== false) {
          that.$emit('input', false);
          that.$emit('close', 'mask');
        }
      } else {
        that.$emit('input', false);
        that.$emit('close', 'close');
      }
    },
    moveHandle() {
      //禁止父元素滑动
    },
    // sku按钮的点击事件
    skuClick(value, index1, index2) {
      let that = this;
      if (value.ishow) {
        if (that.selectArr[index1] != value.name) {
          that.$set(that.selectArr, index1, value.name);
          that.$set(that.subIndex, index1, index2);
        } else {
          that.$set(that.selectArr, index1, '');
          that.$set(that.subIndex, index1, -1);
        }
        that.checkInpath(index1);
        // 如果全部选完
        that.checkSelectShop();
      }
    },
    // 检测是否已经选完sku
    checkSelectShop() {
      let that = this;
      // 如果全部选完
      if (that.selectArr.every((item) => item != '')) {
        that.selectShop = that.shopItemInfo[that.selectArr];
        let stock = that.selectShop[that.stockName];
        if (typeof stock !== 'undefined' && that.selectNum > stock) {
          that.selectNum = stock;
        }
        if (that.selectNum > that.maxBuyNum) {
          that.selectNum = that.maxBuyNum;
        }
        if (that.selectNum < that.minBuyNum) {
          that.selectNum = that.minBuyNum;
        }
        //that.selectNum = that.minBuyNum || 1;
      } else {
        that.selectShop = {};
      }
    },
    // 检查路径
    checkInpath(clickIndex) {
      let that = this;
      let specListName = that.specListName;
      //console.time('筛选可选路径需要的时间是');
      //循环所有属性判断哪些属性可选
      //当前选中的兄弟节点和已选中属性不需要循环
      let specList = that.goodsInfo[specListName];
      if (specList) {
        for (let i = 0, len = specList.length; i < len; i++) {
          if (i == clickIndex) {
            continue;
          }
          let len2 = specList[i].list.length;
          for (let j = 0; j < len2; j++) {
            if (that.subIndex[i] != -1 && j == that.subIndex[i]) {
              continue;
            }
            let choosed_copy = [...that.selectArr];
            that.$set(choosed_copy, i, specList[i].list[j].name);
            let choosed_copy2 = choosed_copy.filter(
              (item) => item !== '' && typeof item !== 'undefined',
            );
            // if (that.shopItemInfo.hasOwnProperty(choosed_copy2))
            if (
              Object.prototype.hasOwnProperty.call(
                that.shopItemInfo,
                choosed_copy2,
              )
            ) {
              specList[i].list[j].ishow = true;
            } else {
              specList[i].list[j].ishow = false;
            }
          }
        }
      }
      that.$set(that.goodsInfo, specListName, specList);
      // console.timeEnd('筛选可选路径需要的时间是');
    },
    // 计算sku里面规格形成路径
    checkItem() {
      let that = this;
      // console.time('计算有多小种可选路径需要的时间是');
      let { stockName } = that;
      let skuListName = that.skuListName;
      // 去除库存小于等于0的商品sku
      let originalSkuList = that.goodsInfo[skuListName];
      let skuList = [];
      let stockNum = 0;
      if (originalSkuList) {
        originalSkuList.map((skuItem, index) => {
          if (skuItem[stockName] > 0) {
            skuList.push(skuItem);
            stockNum += skuItem[stockName];
          }
        });
      }
      if (stockNum <= 0) {
        that.outFoStock = true;
      }
      // 计算有多小种可选路径
      let result = skuList.reduce(
        (arrs, items) => {
          return arrs.concat(
            items[that.skuArrName].reduce(
              (arr, item) => {
                return arr.concat(
                  arr.map((item2) => {
                    // 利用对象属性的唯一性实现二维数组去重
                    // if (!that.shopItemInfo.hasOwnProperty([...item2, item]))
                    if (
                      !Object.prototype.hasOwnProperty.call(that.shopItemInfo, [
                        ...item2,
                        item,
                      ])
                    ) {
                      that.shopItemInfo[[...item2, item]] = items;
                    }
                    return [...item2, item];
                  }),
                );
              },
              [[]],
            ),
          );
        },
        [[]],
      );
      // console.timeEnd('计算有多小种可选路径需要的时间是');
    },
    // 检测sku选项是否已全部选完,且有库存
    checkSelectComplete(obj = {}) {
      let that = this;
      let clickTime = new Date().getTime();
      if (that.clickTime && clickTime - that.clickTime < 400) {
        return false;
      }
      that.clickTime = clickTime;
      let { selectShop, selectNum, stockText, stockName } = that;
      if (!selectShop || !selectShop[that.skuIdName]) {
        alert('请先选择对应规格', 'none');
        return false;
      }
      if (selectNum <= 0) {
        alert('购买数量必须>0', 'none');
        return false;
      }
      // 判断库存
      if (selectNum > selectShop[stockName]) {
        alert(stockText + '不足', 'none');
        return false;
      }
      if (typeof obj.success == 'function') obj.success(selectShop);
    },
    // 加入购物车
    addCart() {
      let that = this;
      that.checkSelectComplete({
        success: function(selectShop) {
          that.tipsShow = true;
          selectShop.buy_num = that.selectNum;
          that.$emit('add-cart', selectShop);
          setTimeout(function() {
            that.init();
          }, 300);
          let num = 5;
          this.intervalId = setInterval(() => {
            if (num) {
              that.tipsShow = false;
              num--;
            } else {
              num = 5;
              clearInterval(this.intervalId);
            }
          }, 3000);
        },
      });
    },
    // 立即购买
    buyNow() {
      let that = this;
      that.checkSelectComplete({
        success: function(selectShop) {
          selectShop.buy_num = that.selectNum;
          that.$emit('buy-now', selectShop);
        },
      });
    },
    // 成功加入购物车
    dialogShow() {
      this.$nextTick(() => {
        this.tipsShow = true;
      });

      // let that = this;
      // that.show = false;
    },
    // 成功加入购物车关闭
    dialogHidden() {
      this.$nextTick(() => {
        this.tipsShow = false;
      });

      // let that = this;
      // that.show = false;
    },
    // 弹窗
    toast(title, icon) {
      // uni.showToast({
      //   title: title,
      //   icon: icon,
      // });
    },
    // 获取对象数组中的某一个item,根据指定的键值
    getListItem(list, key, value) {
      let that = this;
      let item;
      for (let i in list) {
        if (typeof value == 'object') {
          if (JSON.stringify(list[i][key]) === JSON.stringify(value)) {
            item = list[i];
            break;
          }
        } else {
          if (list[i][key] === value) {
            item = list[i];
            break;
          }
        }
      }
      return item;
    },
    getListIndex(list, key, value) {
      let that = this;
      let index = -1;
      for (let i = 0; i < list.length; i++) {
        if (list[i][key] === value) {
          index = i;
          break;
        }
      }
      return index;
    },
    // 自动选择sku前提是只有一组sku,默认自动选择最前面的有库存的sku
    autoClickSku() {
      let that = this;
      let skuList = that.goodsInfo[that.skuListName];
      let specListArr = that.goodsInfo[that.specListName];
      if (specListArr) {
        if (specListArr.length == 1) {
          let specList = specListArr[0].list;
          if (specList) {
            for (let i = 0; i < specList.length; i++) {
              let sku = that.getListItem(skuList, that.skuArrName, [
                specList[i].name,
              ]);
              if (sku) {
                that.skuClick(specList[i], 0, i);
                break;
              }
            }
          }
        }
      }
    },
    // 主题颜色
    themeColorFn(name) {
      let that = this;
      let { theme, themeColor } = that;
      let color = that[name] ? that[name] : themeColor[theme][name];
      return color;
    },
    defaultSelectSku() {
      let that = this;
      let { defaultSelect } = that;
      if (defaultSelect && defaultSelect.sku && defaultSelect.sku.length > 0) {
        that.selectSku(defaultSelect);
      }
    },
    /**
			 * 主动方法 - 设置sku
			that.$refs.skuPopup.selectSku({
				sku:["红色","256G","公开版"],
				num:5
			});
			 */
    selectSku(obj = {}) {
      let that = this;
      let { sku: skuArr, num: selectNum } = obj;
      let specListArr = that.goodsInfo[that.specListName];
      if (skuArr && specListArr.length === skuArr.length) {
        // 先清空
        let skuClickArr = [];
        let clickKey = true;
        for (let index = 0; index < skuArr.length; index++) {
          let skuName = skuArr[index];
          let specList = specListArr[index].list;
          let index1 = index;
          let index2 = that.getListIndex(specList, 'name', skuName);
          if (index2 == -1) {
            clickKey = false;
            break;
          }
          skuClickArr.push({
            spec: specList[index2],
            index1: index1,
            index2: index2,
          });
        }
        if (clickKey) {
          that.init(true);
          skuClickArr.map((item) => {
            that.skuClick(item.spec, item.index1, item.index2);
          });
        }
      }
      if (selectNum > 0) that.selectNum = selectNum;
    },
    priceFilter(n = 0) {
      let that = this;
      if (typeof n == 'string') {
        n = parseFloat(n);
      }
      return n.toFixed(2);
      /*return (n / 100).toFixed(2);*/
    },
    pushGoodsCache(goodsInfo) {
      let that = this;
      let { goodsIdName } = that;
      goodsCache[goodsInfo[goodsIdName]] = goodsInfo;
    },
    // 用于阻止冒泡
    stop() {},
  },
};
</script>

<style lang="less" scoped>
.specification-header {
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  .specification-left {
    width: 460px;
    #product-img {
      width: 460px;
      height: 460px;
    }
    #gallery {
      margin-top: 20px;
    }
    .thumb-list {
      display: block;
      width: 460px;
      height: 80px;
      margin: 0 auto;
      padding: 0;
      overflow: hidden;
      li {
        float: left;
        width: 78px;
        height: 78px;
        margin: 0 7px 0;
        position: relative;
        cursor: pointer;
      }
      img {
        width: 76px;
        height: 76px;
        border: 2px solid #ddd;
      }
      .active img {
        border: 2px solid #31a775 !important;
      }
    }
  }
  .specification-right {
    display: flex;
    flex-direction: column;
    width: 560px;
    padding-left: 40px;
    .title {
      margin: 0 0 20px;
      h1 {
        margin: 0;
        font-weight: normal;
        font-size: 22px;
        line-height: 40px;
      }
    }
    .specification-item {
      margin-bottom: 20px;
    }
    .item-title {
      float: left;
      width: 70px;
      color: #515457;
      line-height: 32px;
    }
    .item-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-left: 70px;
    }
    .item-content {
      display: inline-block;
      box-sizing: border-box;
      width: auto;
      margin: 0 20px 10px 0;
      padding: 0 20px;
      border: 1px solid #ededed;
      border-radius: 16px;
      color: #333333;
      font-size: 14px;
      line-height: 30px;
      background: #f7f7fa;
      cursor: pointer;
    }
    .item-content .actived {
      border-color: #854fc1;
      color: #854fc1;
    }
    .item-content .noactived {
      border-color: #f6f6f6;
      color: #c3c3c3;
      background-color: #f6f6f6;
    }
    .number-box-div {
      display: flex;
      margin-bottom: 30px;
    }
    .tips-dialog {
      width: 356px;
      height: 82px;
      padding: 20px 20px;
      position: absolute;
      top: -50px;
      left: 0;
      border: 1px solid #e1f3d8;
      color: #31a775;
      font-weight: bold;
      font-size: 18px;
      line-height: 40px;
      background: #f0f9eb;
      .delete {
        float: right;
        color: #ccc;
        font-weight: normal;
        font-size: 14px;
        cursor: pointer;
      }
      img {
        width: 26px;
        height: 26px;
        margin-right: 5px;
      }
    }
  }
  .price-content {
    margin-bottom: 30px;
    color: #fe560a;
  }
  .sign {
    font-size: 28px;
    line-height: 1;
  }
  .price {
    margin-left: 4px;
    font-size: 28px;
    line-height: 1;
  }
  .price2 {
    margin-left: 4px;
    font-size: 36px;
  }
  .inventory {
    margin-bottom: 10px;
    color: #999999;
  }
  .choose {
    color: #333333;
  }
}
.btn-wrapper {
  display: flex;
  width: 100%;
  .layer-btn {
    width: 335px;
    height: 76px;
    border-radius: 38px;
    color: #fff;
    font-weight: 500;
    text-align: center;
    &.add-cart {
      background: #ffbe46;
    }
    &.buy {
      background: #fe560a;
    }
  }
  .sure {
    margin-right: 20px;
    padding: 12px 46px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    background: #fe560a;
    cursor: pointer;
  }
  .sure.add-cart {
    background: #ff9402;
  }
}
@keyframes showPopup {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes hidePopup {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes showLayer {
  0% {
    transform: translateY(120%);
  }
  100% {
    transform: translateY(0%);
  }
}
@keyframes hideLayer {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(120%);
  }
}
</style>
